import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
    table: {
        background: theme.palette.secondary.light
    },
    dialogContainer: {
        // padding: theme.spacing(3)
    },
    dialogTitle: {
        textAlign: 'center'
    },
    dialogItemInput: {
        padding: theme.spacing(1)
    },
    dialogInputFile: {
        margin: theme.spacing(1),
        border: `.5px solid ${theme.palette.primary.light}`,
    },
    closeIcon: {
        position: 'absolute',
        right: 4,
        top: 4,
        color: theme.palette.grey[700],
        cursor: 'pointer'
    },
    itemInput: {
        width: '100%'
    },
    formControl: {
        minWidth: '100%'
    },
    select: {
        height: theme.spacing(5)
    },
    fromInput: {
        width: '100%'
        // paddingLeft: theme.spacing(1),
        // paddingRight: theme.spacing(1)
    },
    descriptionColumn: {
        maxWidth: '250px'
    },
    dialogBanner: {
        marginBottom: '10px',
        height: '200px',
        textAlign: 'center',
        position: 'relative',
        width: 'fit-content',
        margin: '0 auto'
    },
    dialogBannerImg: {
        maxWidth: '100%',
        maxHeight: '200px',
        objectFit: 'cover',
        borderRadius: '4px'
    }
}))

export default useStyles
